import { render } from "./PostProcessing.vue?vue&type=template&id=64f7900b&scoped=true"
import script from "./PostProcessing.vue?vue&type=script&lang=js"
export * from "./PostProcessing.vue?vue&type=script&lang=js"

import "./PostProcessing.vue?vue&type=style&index=0&id=64f7900b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64f7900b"

export default script